export interface PaperUploadChunkedEventsData {
  index: number
  lastIndex: number
  chunk: string
  id: number
}

export interface Chunk {
  chunkData: string
  index: number
}

export interface ChunksEvents {
  [key: number]: {
    lastIndex: number
    chunks: Chunk[]
  }
}

export function bindChannelChunking(channel: Pusher.Channel, event: string, callback: (data: any) => void) {
  const events: ChunksEvents = {}
  channel.bind(event, (data: PaperUploadChunkedEventsData) => {
    if (!events.hasOwnProperty(data.id)) {
      events[data.id] = {
        chunks: [],
        lastIndex: data.lastIndex,
      }
    }
    const ev = events[data.id]

    ev.chunks.push({
      chunkData: data.chunk,
      index: data.index,
    })

    if (events[data.id].chunks.length === data.lastIndex + 1) {
      const sortedChunks = ev.chunks
        .sort((a: Chunk, b: Chunk) => (a.index <= b.index ? -1 : 1))
        .map(chunk => chunk.chunkData)
      callback(JSON.parse(decodeURIComponent(sortedChunks.join(''))))
      delete events[data.id]
    }
  })
}
